import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Link, useLocation } from 'react-router-dom';
import { Paper, Grid } from '@material-ui/core';
import moment from "moment";
import { Tooltip } from "@material-ui/core";
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import { DatePickerInput } from 'rc-datepicker';
import Moment from "moment";
import BiztranControls from "../../components/biztran_controls/BiztranControls";
// import ModelFrame from "../../components/biztran_controls/Modal_Frame";
import UseFetchData from "../../hooks/UseFetchData";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";


const todate = new Date();
const fromdate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate() - 60);


const StockStatus = () => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const [Count, setCount] = useState('');
  const [DocumentTypecmb, setDocumentTypecmb] = useState([]);
  const [TransactionStoreID, setTransactionStoreID] = useState('');
  const [TransactionStorecmb, setTransactionStorecmb] = useState([]);
  const [FromDate, setFromDate] = useState(fromdate.toISOString());
  const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
  const [ToDate, setToDate] = useState(todate.toISOString());
  const [defaultToDate, setdefaultToDate] = useState(todate);
  const [responseTransactionStore, fetchTransactionStoreData] = UseFetchData();
  const [response, fetchData] = UseFetchData();
  const [InventoryDocumentID, setInventoryDocumentID] = useState('')
  const [DocumentNo, setDocumentNo] = useState('');
  const [AccountID, setAccountID] = useState('');
  const [ModelCode, setModelCode] = useState('');
  const [AccountName, setAccountName] = useState('');
  const [AccountOptions, setAccountOptions] = useState([]);
  const [responseProduct, fetchProductData] = UseFetchData();
  const [ProductGroupcmb, setProductGroupcmb] = useState([]);
  const [ProductGroupID, setProductGroupID] = useState('');
  const [Productcmb, setProductcmb] = useState([]);
  const [ProductID, setProductID] = useState('');
  const [radioValue, setRadioValue] = useState('No');


  const onFromClear = () => {
    setFromDate();
    setdefaultfromDate();
  }

  const onToClear = () => {
    setToDate();
    setdefaultToDate();
  }

  // const handleOpenModal = () => {
  //   setOpen(true);
  //   setInventoryDocumentID('');
  // }


  const PopulateData = () => {
    debugger;
    var PGID = "";
    var AccoName = "";
    var bodyFormData = new FormData();
    if (AccountName !== undefined) {
      AccoName = AccountName.List;
    }
    else {
      AccoName = "";
    }
    if (ProductGroupID !== "") {
      PGID = ProductGroupID;
    }
    var bodyFormData = new FormData();
    bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));;
    bodyFormData.append("ProductGroupID", ProductGroupID);
    bodyFormData.append("ProductID", ProductID);
    bodyFormData.append("TransactionStoreID", TransactionStoreID);
    bodyFormData.append("AccountName", AccoName);
    bodyFormData.append("ModelCode", ModelCode);
    bodyFormData.append("StockEmpty", radioValue);
    fetchData("StockStatus/StockStatusList", bodyFormData);
  };

  const GetComboData = () => {
    var bodyFormData = new FormData();
    fetchTransactionStoreData("StockStatus/ComboData", bodyFormData);
  };


  useEffect(() => {
    if (responseTransactionStore !== undefined) {
      // debugger;
      if (responseTransactionStore["cmbStore"] !== undefined) {
        setTransactionStorecmb(responseTransactionStore["cmbStore"]);
      }
      else {
        setTransactionStorecmb([]);
      }
      if (responseTransactionStore['cmbAccount'] !== undefined) {
        setAccountOptions(responseTransactionStore['cmbAccount']);
      }
      else {
        setAccountOptions([]);
      }
      if (responseTransactionStore['cmbProductGroup'] !== undefined) {
        setProductGroupcmb(responseTransactionStore['cmbProductGroup']);
      }
      else {
        setProductGroupcmb([]);
      }
      if (responseTransactionStore['Productcmb'] !== undefined) {
        setProductcmb(responseTransactionStore['Productcmb']);
      }
      else {
        setProductcmb([]);
      }

    }
  }, [responseTransactionStore]);


  useEffect(() => {
    PopulateData();
    GetComboData();
  }, [])

  const handleChange = (event) => {
    setRadioValue(event.target.value);
  };

  const items = [
    { id: 'No', title: 'No' },
    { id: 'Yes', title: 'Yes' },
  ];

  const onACCChange = (event, newValue) => {
    // debugger;
    setAccountName(newValue);
    setAccountID(newValue.id);
  }

  useEffect(() => {
    const gridCols = [
      // {
      //   field: "id",
      //   headerName: ".",
      //   renderCell: (params) => (<strong> <Link to={{ pathname: "/StockLedger/StockLedgerView", state: { InventoryDocumentID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
      //   //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 10,
      // },
      {
        field: "StoreName",
        headerName: "Store",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,

      },
      {
        field: "ModelCode",
        headerName: "ModelCode",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        renderCell: (params) => (
          <Tooltip title={params.row.ModelCode} >
            <span className="table-cell-trucate">{params.row.ModelCode}</span>
          </Tooltip>
        )
      },
      {
        field: "ProductName",
        headerName: "Product",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        renderCell: (params) => (
          <Tooltip title={params.row.ProductName} >
            <span className="table-cell-trucate">{params.row.ProductName}</span>
          </Tooltip>
        )
      },
      {
        field: "ProductGroup",
        headerName: "Product Group",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
        renderCell: (params) => (
          <Tooltip title={params.row.ProductGroup} >
            <span className="table-cell-trucate">{params.row.ProductGroup}</span>
          </Tooltip>
        )
      },
      {
        field: "Rate",
        headerName: "Rate",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 220,
      },
      {
        field: "OpBal",
        headerName: "OpeningBalance",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      },
      {
        field: "ToInQty",
        headerName: "ToInQty",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 240,
      },
      {
        field: "ToOutQty",
        headerName: "ToOutQty",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 190,
      },
      {
        field: "ClBal",
        headerName: "CIBal",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 170,
      },
    ];
    setColumns(gridCols);
    setRows(response);
    setCount(response.length);
  }, [response]);



  useEffect(() => {
    PopulateData();
  }, [])

  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ marginLeft: '93%' }}>
        <GridToolbarExport csvOptions={{
          fields: ['StoreName', 'ModelCode', 'ProductName', 'ProductGroup', 'Rate', 'OpBal', 'ToInQty', 'ToOutQty', 'ClBal']
        }} />
      </GridToolbarContainer>
    );
  }

  return (
    <div >
      <Grid container direction="row" style={{ marginTop: -10 }} >
        <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
          <div style={{ width: "200px", marginLeft: 17 }}>
            <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setFromDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onFromClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultfromDate}
            />
          </div>
        </Grid>
        <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
          <div style={{ width: "200px", marginLeft: 5 }}>
            <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setToDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onToClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultToDate}
            />
          </div>
        </Grid>
        <Grid>
          <BiztranControls.Input
            label="Model Code"
            id="ModelCode"
            style={{ width: "200px", marginTop: 20 }}
            onChange={(e) => setModelCode(e.target.value)}
          />
        </Grid>
        <Grid >
          <BiztranControls.RadioGroup
            name="myRadioGroup"
            label="Nil Stock"
            value={radioValue}
            onChange={handleChange}
            items={items}
          //style={{ Height: 10 }}
          //onChange={(e) => setModelCode(e.target.value)}
          />
        </Grid>

      </Grid>
      <Grid container direction="row" style={{ marginTop: 20 }}>

        <BiztranControls.Select
          label="Transaction Store"
          id="TransactionStore"
          style={{ width: "200px", marginLeft: 10, marginTop: -10, marginRight: 10 }}
          options={TransactionStorecmb}
          onChange={(e) => setTransactionStoreID(e.target.value)}
        />
        <BiztranControls.Select
          label="ProductGroup"
          id="ProductGroup"
          style={{ width: 'maxWidth', marginTop: -8 }}
          options={ProductGroupcmb}
          onChange={(e) => setProductGroupID(e.target.value)}
        />
        <BiztranControls.Select
          label="Product"
          id="Product"
          style={{ width: 'maxWidth', marginTop: -8 }}
          options={Productcmb}
          onChange={(e) => setProductID(e.target.value)}
        />
        <label style={{ fontWeight: 'bold', width: 30, marginTop: 15, marginLeft: 7 }}>{Count}</label>
        <BiztranControls.Button
          responsive="true"
          text="Populate"
          startIcon={<SearchIcon />}
          onClick={() => {
            PopulateData();
          }}
        />


      </Grid>
      <BiztranControls.DataGrid
        headerHeight={34}
        rowHeight={25}
        rows={rows}
        columns={columns}
        checkboxSelection={false}
        Height="400px"
        Width="100%"
        components={{ Toolbar: CustomToolbar, }}

      />
    </div >
  );
};

export default StockStatus;
